import script from "./QuestionnaireDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./QuestionnaireDialog.vue?vue&type=script&setup=true&lang=js"

import "./QuestionnaireDialog.vue?vue&type=style&index=0&id=4c817ccd&lang=scss"

const __exports__ = script;

export default __exports__